import { createApp } from 'vue'
// 组件本身由 unplugin-vue-components 按需引入；
// 样式整体引入一次，避免 ElMessage 等命令式 API 少样式（它们不经过模板解析）。
import 'element-plus/dist/index.css'
// 令牌必须在 Element 之后加载，否则覆盖不到它的默认变量
import './styles/tokens.css'
import './styles/element-theme.css'
import './styles/motion.css'
import './styles/page.css'
import router from './router'
import App from './App.vue'
import './style.css'

const app = createApp(App)

app.use(router)
app.mount('#app')
